import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import "./style.sass";
import { useServices } from 'hooks/useServices';
import { useIsMobile } from 'hooks/useIsMobile';
import SlidersEmarsys from 'components/Emarsys/SlidersEmarsys/index_product';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { useHomePage } from 'hooks/useHomePage';
import { useForm } from 'react-hook-form';

export function PantallaComenzarIncode() {

    const history = useHistory();
    const { isMobile } = useIsMobile();


    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'Before Start  Credit-Page');
        window.ineum('meta', 'portal', 'Credito CS');
        window.scrollTo(0, 0);
    }, [])

    const cancelar = () => {
        //history.replace(`${BASE_PATH}`);
        history.goBack(-1);
    }

    const [permisos, setPermisos] = useState(false);

    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            permisos: false
        }
    });

    const sendFormInformacionFinanciera = data => {
        console.log(data);
        history.push(`${BASE_PATH}${SUB_DIRECTORY}comenzar-solicitud`);
    };

    const valPermisos = {
        required: 'Campo obligatorio',
    };

    const seleccionarPermisos = (e) => {
        setPermisos(e.target.value);
    };


    return (
        <div className={isMobile === "desktop" ? "" : "homeMobile"}>
            {isMobile === "desktop"
                ? <Header type="complete" />
                : <HeaderMobileCredito title={""} type="backFull" />
            }
            <main className='nuevoCredito'>
                <form onSubmit={handleSubmit(sendFormInformacionFinanciera)}>
                    <section className="sectionPrincipalBeneficios incode-comenzar">
                        <div className="contenido">
                            <div className="contenedorLandingBeneficios">

                                <div className=''>
                                    
                                    <div className='subt'>
                                        <h1 className='bold fontsize22'>¡COMENCEMOS!</h1>
                                    </div>

                                    <p className='top'>Es necesario escanear verticalmente tu documento donde aparece tu foto</p>

                                    <div className='contentImage'>
                                        <div className="boxImage">
                                            <img src={`${BASE_PATH}${SUB_DIRECTORY}/img/documento_frente.png`} className="img" alt="banner-principal" />
                                        </div>
                                    </div>                                                           

                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="boxBtnSolicitar marginBottom30">
                        <button className="btnSolicitar">Comenzar</button>
                    </div>
                </form>
            </main>
        </div>
    )
}